import { useEffect, useRef } from "react";

const STORAGE_KEY = "app-build-id";
const META_TAG_NAME = "app-build-id";

const PLACEHOLDER_VALUES = new Set(["%REACT_APP_BUILD_ID%", "%REACT_APP_BUILD_VERSION%"]);

function getBuildId(): string | undefined {
  if (typeof document === "undefined") {
    return undefined;
  }

  const meta = document.querySelector(`meta[name="${META_TAG_NAME}"]`);
  const metaContent = meta?.getAttribute("content")?.trim();
  if (metaContent && !PLACEHOLDER_VALUES.has(metaContent)) {
    return metaContent;
  }

  const envValue = process.env.REACT_APP_BUILD_ID?.trim();
  if (envValue && !PLACEHOLDER_VALUES.has(envValue)) {
    return envValue;
  }

  return undefined;
}

export default function useAutoRefreshOnDeploy() {
  const hasReloadedRef = useRef(false);

  useEffect(() => {
    const buildId = getBuildId();
    if (!buildId) {
      return;
    }

    const storedBuildId = localStorage.getItem(STORAGE_KEY);

    if (storedBuildId && storedBuildId !== buildId) {
      localStorage.setItem(STORAGE_KEY, buildId);
      if (!hasReloadedRef.current) {
        hasReloadedRef.current = true;
        window.location.reload();
      }
      return;
    }

    if (!storedBuildId) {
      localStorage.setItem(STORAGE_KEY, buildId);
    }
  }, []);
}
